import "vant/es/toast/style";
import _Toast from "vant/es/toast";
/*
 *                        _oo0oo_
 *                       o8888888o
 *                       88" . "88
 *                       (| -_- |)
 *                       0\  =  /0
 *                     ___/`---'\___
 *                   .' \\|     |// '.
 *                  / \\|||  :  |||// \
 *                 / _||||| -:- |||||- \
 *                |   | \\\  - /// |   |
 *                | \_|  ''\---/''  |_/ |
 *                \  .-\__  '-'  ___/-. /
 *              ___'. .'  /--.--\  `. .'___
 *           ."" '<  `.___\_<|>_/___.' >' "".
 *          | | :  `- \`.;`\ _ /`;.`/ - ` : | |
 *          \  \ `_.   \_ __\ /__ _/   .-` /  /
 *      =====`-.____`.___ \_____/___.-`___.-'=====
 *                        `=---='
 *
 *
 *      ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 *
 *            佛祖保佑   永不宕机   永无BUG
 *                        rxl
 */

import axios from 'axios';
/**
 * @description: http请求错误提示弹框
 * @param {*}  option => { msg , code , config }
 * @return {*}
 */
// const toastMsg = (option) => {
//   const RESPONSE_CODE = {
//     400: '请求参数错误',
//     403: '拒绝访问',
//     404: '请求超时',
//     500: '服务器内部错误',
//     501: '服务未实现',
//     502: '网关错误',
//     503: '服务不可用',
//     504: '网关超时',
//     505: 'HTTP版本不受支持',
//   }
//   const errorMsg = option.msg || RESPONSE_CODE[option.code] || '服务器开小差！！'
//   // 是否需要显示错误提示框   eg: await testApi({ isVisibleToast: true, data: options })
//   if (option.config.hideToast) return
//   if (!option.config.hideToast) return
//   console.log(errorMsg) 
//   Toast.fail(errorMsg)
// }
/**
 * 包裹await
 * @param {Promise} promise 一个异步promise函数
 */
const awaitWrap = promise => {
  try {
    return promise.then(({
      code,
      data,
      msg
    }) => ({
      err: null,
      code,
      data,
      msg
    })).catch(err => ({
      err,
      data: null
    }));
  } catch (err) {
    return {
      err,
      data: null
    };
  }
};
const instance = axios.create({
  baseURL: process.env.NODE_ENV === 'dev' ? '' : process.env.VUE_APP_REQUEST_URL,
  // withCredentials: true, // 跨域请求需要携带cookie
  timeout: 60000 // 超时时间
});

instance.interceptors.request.use(config => {
  // 自定义headers
  config.headers.authorization = window.localStorage.getItem('token') || '';
  return config;
}, error => Promise.reject(error));
instance.interceptors.response.use(response => {
  const {
    data,
    config
  } = response;
  if (data.code !== 0 && data.code !== 200) {
    if (!config.hideToast) {
      _Toast.fail(data.msg);
    }
    return Promise.reject(response);
  }
  return Promise.resolve(data);
}, error => {
  // const { status, config } = error.response
  // toastMsg({ code: status, config })
  return Promise.reject(error);
});

/**
 * @description: axios Promise 请求封装
 * @param { method: http请求方式 , url: 接口地址 , options: 可选参数 }
 * @return {*}
 */
const request = (method, url, options = {}) => {
  const requestConfig = {
    method,
    url,
    ...options
  };
  const promise = new Promise((resolve, reject) => {
    instance.request(requestConfig).then(res => {
      resolve(res);
    }).catch(err => {
      reject(err);
    });
  });
  return awaitWrap(promise);
};
export { request };